export const helpIconKpiTitles = ["Total suggested orders", "Total opportunity value", "Customer Daily on Hand(DoH)", "Critical DoH line (<1DoH)"];
export const sortableColsOrderVisibility = ['DRR', 'DOH', 'Norm days', 'Suggested orders'];
export const dispatchPrioritySortingCols = ['DRR', 'Norm days', 'Min Dispatch Qty', 'Max Dispatch Qty', 'Priority'];
export const highRiskSKUColumns = ['CBU Description', 'Customer Name', 'Stock in hand', 'Ideal | Open orders', 'Suggested orders'];

export const currancyInRupees = (amount) => {
    const formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const value = formatter.format(amount);

    return value.split('₹')[1];
};